import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api";
import type { RawMaterialInfo, SPCResponse } from "@shared/types";
export type { RawMaterialInfo };

export function useRawMaterials() {
  return useQuery({
    queryKey: ["raw-materials"],
    queryFn: () => apiFetch<RawMaterialInfo[]>("/api/raw-materials/materials"),
    staleTime: Infinity,
  });
}

export function useRawMaterialSPC(
  material: string | null,
  test: string | null,
  from: string,
  to: string,
  _productType?: string,
  supplier?: string
) {
  return useQuery({
    queryKey: ["raw-materials", "spc", material, test, from, to, supplier],
    queryFn: () =>
      apiFetch<SPCResponse>("/api/raw-materials/spc", {
        material: material!,
        test: test!,
        from,
        to,
        supplier: supplier || undefined,
      }),
    enabled: material !== null && test !== null,
  });
}

export function useRawMaterialTests() {
  return useQuery({
    queryKey: ["raw-materials", "tests"],
    queryFn: () =>
      apiFetch<{ key: string; label: string; unit: string; column: string }[]>(
        "/api/raw-materials/tests"
      ),
    staleTime: Infinity,
  });
}

export function useRawMaterialSuppliers(material: string | null) {
  return useQuery({
    queryKey: ["raw-materials", "suppliers", material],
    queryFn: () =>
      apiFetch<string[]>("/api/raw-materials/suppliers", {
        material: material!,
      }),
    enabled: material !== null,
  });
}
